export const APP_STATES = {
	QUESTION: 'QUESTION',
	SUCCESS: 'SUCCESS',
	FAILURE: 'FAILURE',
	VHK: 'VHK'
};

export const QUESTIONS = [
	{
		questionText:
			'A vásárolni vagy építeni kívánt ingatlan értéke/bekerülési költsége lakás esetén legfeljebb bruttó 100 millió Ft, egylakásos lakóépület (lakóház, tanya, birtokközpont) legfeljebb bruttó 150 millió Ft?',
		model: 'underGrossPriceBound',
		vhkModel: 'bruttó árlimit alatt',
		answers: [
			{ key: true, value: 'Igen', vhkValue: 'igen' },
			{ key: false, value: 'Nem', vhkValue: 'nem', failure: true }
		]
	},
	{
		questionText: 'Az ingatlan alapterületre számított négyzetméterára maximum bruttó 1,5 millió Ft?',
		model: 'underSquareMeterPriceBound',
		vhkModel: 'négyzetméter árlimit alatt',
		answers: [
			{ key: true, value: 'Igen', vhkValue: 'igen' },
			{ key: false, value: 'Nem', vhkValue: 'nem', failure: true }
		]
	},
	{
		questionText:
			'A vásárolt vagy építendő ingatlan kizárólagos tulajdonosa lesz? (Házastárssal történő igénylés esetén csak ketten szereznek tulajdonjogot?)',
		model: 'onlyOwner',
		vhkModel: 'egyedüli tulajdonos',
		answers: [
			{ key: true, value: 'Igen', vhkValue: 'igen' },
			{ key: false, value: 'Nem', vhkValue: 'nem', failure: true }
		]
	},
	{
		questionText: 'Az eladó vagy az építési tevékenységet végző személy közeli hozzátartozója vagy élettársa?',
		model: 'isOwnerClose',
		vhkModel: 'az eladó vagy építő közeli hozzáartozó',
		answers: [
			{ key: false, value: 'Nem', vhkValue: 'nem' },
			{ key: true, value: 'Igen', vhkValue: 'igen', failure: true }
		]
	},
	{
		questionText: 'Jelenleg van-e, vagy volt-e az elmúlt 10 évben belterületi lakóingatlanban tulajdona?',
		model: 'hadProperty',
		vhkModel: 'van-e a tulajdonában ingatlan',
		answers: [
			{ key: false, value: 'Nem', vhkValue: 'nem', nextStep: 7 },
			{ key: true, value: 'Igen', vhkValue: 'igen' }
		]
	},
	{
		questionText: 'Egyidejűleg, egy belterületi lakóingatlanban maximum 50%-os tulajdoni hányaddal rendelkezik/rendelkezett?',
		questionDetail:
			'(Ha a régi lakás tulajdonjogát legfeljebb 180 napon belül törlik, miután az új lakás tulajdonjogát bejegyezték, akkor ez nem számít egyidejű tulajdonlásnak, így a hitel igényelhető.)',
		model: 'maxHalfProperty',
		vhkModel: 'max 50%-os tulajdonjoga van',
		answers: [
			{ key: true, value: 'Igen', vhkValue: 'igen', nextStep: 7 },
			{ key: false, value: 'Nem', vhkValue: 'nem' }
		]
	},
	{
		questionText:
			'Van vagy volt további 1 vagy több belterületi lakóingatlanban tulajdoni hányada, azonban az(ok) megfelelnek az alábbi kivételszabályok valamelyikének:',
		questionHtml: `<ul class="sf-list" style="text-align: left;">
			<li class="sf-listitem" style="margin-bottom: 0px;">a tulajdoni hányadának aktuális értéke vagy eladott ingatlan esetén az adásvételi szerződésben szereplő vételára maximum 15 millió Ft,</li>
			<li class="sf-listitem" style="margin-bottom: 0px;">haszonélvezettel terhelten került a tulajdonába és az ingatlanban jelenleg is ugyanaz a haszonélvező lakik, vagy eladás esetén az elidegenítéskor ugyanazon haszonélvező lakott,</li>
			<li class="sf-listitem" style="margin-bottom: 0px;">lebontását a hatóság engedélyezte/elrendelte vagy amelyet lebontott, vagy lebontatott?</li>
		</ul>`,
		model: 'ownedPropertyCostsLessThanBound',
		vhkModel: 'maximum 15 millió forint értékű ingatlannal rendelkezik',
		answers: [
			{ key: true, value: 'Igen', vhkValue: 'igen' },
			{ key: false, value: 'Nem', vhkValue: 'nem', failure: true }
		]
	},
	{
		questionText: 'Betöltötte a 18. életévét?',
		model: 'isOver18Years',
		vhkModel: '18 évet betöltötte',
		answers: [
			{ key: true, value: 'Igen', vhkValue: 'igen' },
			{ key: false, value: 'Nem', vhkValue: 'nem', failure: true }
		]
	},
	{
		questionText: 'Büntetlen előéletű?',
		model: 'hasCriminalRecord',
		vhkModel: 'büntetlen előéletű',
		answers: [
			{ key: true, value: 'Igen', vhkValue: 'igen' },
			{ key: false, value: 'Nem', vhkValue: 'nem', failure: true }
		]
	},
	{
		questionText:
			'Van 5 ezer forintnál nagyobb összegű köztartozása? Ha van, várhatóan fenn fog állni a kölcsönkérelem benyújtásának időpontjában is?',
		model: 'hasDebt',
		vhkModel: '5 ezer forintál nagyobb tartozás',
		answers: [
			{ key: false, value: 'Nem', vhkValue: 'nem' },
			{ key: true, value: 'Igen', vhkValue: 'igen', failure: true }
		]
	},
	{
		questionText:
			'Kötelezte önt járási hivatal, a kormányhivatal vagy az állami adóhatóság illetve bíróság egyéb lakáscélú állami támogatásokról szóló jogszabályok szerint igénybe vett lakáscélú állami támogatás vagy támogatott lakáscélú kölcsön visszafizetésére az igénylést megelőző 3 évben?',
		model: 'wasRequiredToPayback',
		vhkModel: 'támogatott lakáscélú kölcsön visszafizetési kötelezettség',
		answers: [
			{ key: false, value: 'Nem', vhkValue: 'nem' },
			{ key: true, value: 'Igen', vhkValue: 'igen', failure: true }
		]
	},
	{
		questionText: 'Van a Központi Hitelnyilvántartó Rendszerben (KHR) nyilvántartott lejárt tartozása?',
		model: 'hasExpiredKhr',
		vhkModel: 'lejárt KHR tartozás',
		answers: [
			{ key: false, value: 'Nem', vhkValue: 'nem' },
			{ key: true, value: 'Igen', vhkValue: 'igen', failure: true }
		]
	},
	{
		questionText:
			'Otthon Start program keretében biztosított lakáshitelt első alkalommal veszi igénybe, és sem igénylőként sem adóstársként más Otthon Start hitelügyletben nem szerepel?',
		model: 'firstUseOfLoan',
		vhkModel: 'első alkalommal veszi igénybe',
		answers: [
			{ key: true, value: 'Igen', vhkValue: 'igen' },
			{ key: false, value: 'Nem', vhkValue: 'nem', failure: true }
		]
	},
	{
		questionText: 'Rendelkezik legalább 2 éve folyamatosan az alábbi tb-jogviszony valamelyikével, amit okirattal tud igazolni?',
		questionHtml: `<ul class="sf-list" style="text-align: left;">
			<li class="sf-listitem" style="margin-bottom: 0px;">Munkaviszonyban foglalkoztatott</li>
			<li class="sf-listitem" style="margin-bottom: 0px;">Nyugdíj mellett kiegészítő tevékenységet folytató</li>
			<li class="sf-listitem" style="margin-bottom: 0px;">Alkalmi munkavállaló és legalább 200 napot dolgozott</li>
			<li class="sf-listitem" style="margin-bottom: 0px;">Gyermekek otthongondozási díjában vagy ápolási díjban részesül</li>
			<li class="sf-listitem" style="margin-bottom: 0px;">Megváltozott munkaképességű személynek minősül</li>
			<li class="sf-listitem" style="margin-bottom: 0px;">Közép- vagy felsőoktatási intézményben nappali tagozaton tanuló vagy szakképző intézményben nappali rendszerű oktatás keretében tanulmányokat folytat vagy szünetelteti tanulói jogviszonyát, de iskolaszövetkezeten keresztül dolgozik és nem töltötte be a 25. életévét</li>
		</ul>`,
		model: 'hasInsurance',
		vhkModel: '2 éve van TB jogviszonya',
		answers: [
			{ key: true, value: 'Igen', vhkValue: 'igen' },
			{ key: false, value: 'Nem', vhkValue: 'nem', failure: true }
		]
	},
	{
		questionText:
			'A tb-jogviszonyban volt egybefüggően 30 napnál hosszabb, vagy felsőoktatási hallgatói jogviszony megszűnése esetén 6 hónapnál hosszabb megszakítása?',
		model: 'insurancePaused',
		vhkModel: 'volt TB jogviszony megszakítása',
		answers: [
			{ key: false, value: 'Nem', vhkValue: 'nem' },
			{ key: true, value: 'Igen', vhkValue: 'igen', failure: true }
		]
	},
	{
		questionText:
			'A kölcsön igénylését megelőző 180 napos időtartamban a foglalkoztatása vagy hallgatói jogviszonya Magyarországon teljesült, vagy magyar állampolgárként ingázóként szomszédos országban dolgozik és magyarországi lakcímmel rendelkezik?',
		model: 'hasHungarianAddress',
		vhkModel: 'magyar lakcím',
		answers: [
			{ key: true, value: 'Igen', vhkValue: 'igen', nextStep: 'feedback' },
			{ key: false, value: 'Nem', vhkValue: 'nem', failure: true }
		]
	}
];
